import { useState } from "react";
import ShowIcon from "../../../assets/icons/show.svg";
import HideIcon from "../../../assets/icons/hide.svg";

const Input = ({
  form,
  errors,
  title,
  info,
  icon,
  placeholder,
  id,
  type,
  style,
  direction = "rtl",
  disabled,
}: any) => {
  const [inputType, setInputType] = useState(type);

  return (
    <div className={`${disabled ? "disable-input" : ""}`}>
      <div className="label">
        <span className="label-text">{title}</span>
      </div>
      <label
        style={{ direction: direction }}
        className="input flex items-center gap-2 bg-white border-[1px] border-gray-300"
      >
        {icon}

        <input
          className={`grow ${direction === "rtl" ? "pr-2" : "pl-2"}`}
          type={type === "password" ? inputType : type}
          {...form.register(id)}
          id={id}
          placeholder={placeholder}
          style={style}
          min={0}
          disabled={disabled}
        />

        {type === "password" &&
          (inputType === "password" ? (
            <img
              alt="رمز عبور"
              src={ShowIcon}
              style={{ cursor: "pointer" }}
              onClick={() => setInputType("text")}
            />
          ) : (
            <img
              alt="رمز عبور"
              src={HideIcon}
              style={{ cursor: "pointer" }}
              onClick={() => setInputType("password")}
            />
          ))}
      </label>

      {info && (
        <div className="label mb-0 pb-0">
          <span className="label-text-alt mb-0 pb-0">
            <span className="text-gray-400">{info}</span>
          </span>
        </div>
      )}

      <div className="label">
        <span className="label-text-alt">
          {errors[id] && (
            <span style={{ color: "red" }}>{errors[id].message}</span>
          )}
        </span>
      </div>
    </div>
  );
};

export default Input;
